var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tt-avatar",style:(_vm.compAvatar),on:{"click":_vm.emitClick,"mouseleave":_vm.emitMouseLeave,"mouseover":_vm.emitMouseOver,"touchstart":_vm.emitTouchStart,"touchend":_vm.emitTouchEnd}})}
var staticRenderFns = []

export { render, staticRenderFns }